const ar = {
  hello: 'مرحبا',
  welcome: 'أهلا بك',
  lang: 'عربى',
};

export default ar;
